import Modal from 'react-modal';
import PropTypes from 'prop-types';
import Button, { BUTTON_TYPES } from '../../Button';
import "../../../styles/AdminPage.css";
import { FaTimes } from "react-icons/fa";
import TextInput from '../../inputs/TextInput';
import NumberInput from '../../inputs/NumberInput';
import React , {useEffect, useState} from 'react';
import { createSwagItem, deleteSwagItem, updateSwagItem } from '../../../api/admin/AdminSettingsAPI';
import AdminSettingsEditModal from './AdminSettingsEditModal';
import InputContainer from './InputContainer';
import toast from 'react-hot-toast';

Modal.setAppElement('#root');

const EditSwagModal = ({ isOpen, onClose, isAdding, item, setItems }) => {    
    const [localSwagName, setLocalSwagName] = useState("");
    const [localSemestersRequired, setLocalSemestersRequired] = useState(0);

    useEffect(() => {
        if (!isAdding && item) {
            setLocalSwagName(item.rewardName);
            setLocalSemestersRequired(item.activeSemestersRequired);
        }
    }, [isAdding, item]);

    const modalTitle = isAdding ? "Add Swag Item" : "Edit Swag Item";

    const handleConfirm = async () => {
        let swagData;

        if (isAdding) {
            swagData  = {
                rewardName: localSwagName,
                activeSemestersRequired: localSemestersRequired
            };

            try {
                toast.loading("Creating Swag Item...");
                const response = await createSwagItem(swagData);
                setTimeout(async () => {
                    if (response.ok) {
                        toast.dismiss();
                        try {
                            const newSwag = await response.json();
                            toast.success("Swag Item created!");
                            setItems((prev) => [...(prev ?? []), newSwag]);
                            onClose();
                        } catch (jsonError) {
                            console.error("Error parsing JSON:", jsonError);
                            toast.error("Error parsing server response.");
                        }
                    } else {
                        toast.dismiss();
                        console.log("Error creating Swag Item. Status:", response.status);
                        toast.error("Swag Item failed to create. Status: " + response.status);
                    }
                    
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting Swag Item:", error);
                alert("Something went wrong. Please check your connection and try again.");

            }
        } else {
            swagData  = {
                id: item.id,
                rewardName: localSwagName,
                activeSemestersRequired: localSemestersRequired
            };
            try {
                toast.loading("Updaing Swag Item...");
                const response = await updateSwagItem(swagData);
                setTimeout(async () => {
                        if (response.ok) {
                            toast.dismiss();
                            try {
                                toast.success("Swag Item updated!");
                                setItems((prev) => (prev ?? []).map(s => s.id === item.id ? swagData : s));
                                onClose();
                            } catch (jsonError) {
                                console.error("Error parsing JSON:", jsonError);
                                toast.error("Error parsing server response.");
                            }
                        } else {
                            toast.dismiss();
                            console.log("Error updating Swag Item. Status:", response.status);
                            toast.error("Swag Item failed to create. Status: " + response.status);
                        }
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting Swag Item:", error);
                alert("Something went wrong. Please check your connection and try again.");
            }
        }
    };

    const content = (
        <>
            <InputContainer>
                <TextInput
                    id="swag-name"
                    placeholder="Enter Swag Name"
                    label='Swag Item Name'
                    value={localSwagName}
                    setValue={(e) => setLocalSwagName(e.target.value)}
                />
            </InputContainer>
            <InputContainer>
                <NumberInput
                    id="swag-requirement"
                    placeholder="Enter Swag Requirement"
                    label='Active Semesters Required'
                    min={0}
                    value={localSemestersRequired}
                    setValue={(e) => setLocalSemestersRequired(e.target.value)}
                />
            </InputContainer>
            
        </>
    );

    return (
        <AdminSettingsEditModal
            modalTitle={modalTitle}
            content={content}
            isOpen={isOpen}
            onClose={onClose}
            handleConfirm={handleConfirm}
        />
    );
};

EditSwagModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default EditSwagModal;